import React from "react";
import { getTrackBackground } from "react-range";

interface SliderTrackProps {
    props: any;
    children: React.ReactNode;
    values: number[];
    min: number;
    max: number;
}

export const SliderTrack: React.FC<SliderTrackProps> = ({ props, children, values, min, max }) => (
    <div
        onMouseDown={props.onMouseDown}
        onTouchStart={props.onTouchStart}
        style={{
            ...props.style,
            height: "36px",
            display: "flex",
            width: "100%",
        }}
    >
        <div
            ref={props.ref}
            style={{
                height: "6px",
                width: "100%",
                borderRadius: "4px",
                background: getTrackBackground({
                    values,
                    colors: ['rgba(242, 242, 242, 1)', 'rgba(219, 219, 219, 1)', 'rgba(242, 242, 242, 1)'],
                    min: min,
                    max: max,
                }),
                alignSelf: "center",
            }}
        >
            {children}
        </div>
    </div>
);